<template>
  <div class="results-listings relative">
    <div class="loading-overlay" v-if="loading"></div>

    <div class="wrapper" v-if="showResultsSummary">
      <div class="row resultsbar" v-cloak>
        <div class="col-md-7">
          <span>{{totalPosts}}</span><span> Results</span> <span v-if="resultsSummary.length">for: </span>
          <span v-for="(tag, index) in resultsSummary" v-if="tag.name" v-bind:key="index" class="resultsbar-tag">
            {{tag.name}}
            <span class="fa fa-times-circle" @click="deselect(tag, index)"></span>
          </span>
        </div>
      </div>
    </div>


    <div class="locations-map">
      <div class="search-map">
        <v-map :zoom=6 :center="[36.7783, -119.4179]" :options="mapOptions">
        <v-tilelayer url="https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZXZhbi1hdC1kYXlsaWdodCIsImEiOiJjajkyNWp2Ym0zZGs3MnFtYjdtczJyazl3In0.lN2mSz4P19QfZ0HTOUxeEg"></v-tilelayer>
        <v-marker-cluster :options="clusterOptions">
          <v-marker v-for="inn in inns" :lat-lng="inn.location">
            <v-popup :content="popupMarkup(inn)"></v-popup>
          </v-marker>
        </v-marker-cluster>
        </v-map>
      </div>
    </div>
  </div>


</template>

<script>
import { REST } from "./Rest.js";
import Bus from "./Bus.js";
import resultsSummary from "./mixins/resultsSummary.js";
import Map from "./leaflet/src/components/Map.vue";
import Marker from "./leaflet/src/components/Marker.vue";
import Popup from "./leaflet/src/components/Popup.vue";
import TileLayer from "./leaflet/src/components/TileLayer.vue";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";

const mapToken =
  "pk.eyJ1IjoiZXZhbi1hdC1kYXlsaWdodCIsImEiOiJjajkyNWp2Ym0zZGs3MnFtYjdtczJyazl3In0.lN2mSz4P19QfZ0HTOUxeEg";

export default {
  name: "search-map",

  components: {
    "v-map": Map,
    "v-tilelayer": TileLayer,
    "v-marker": Marker,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    "v-popup": Popup
  },

  props: {
    getPostsOnMount: {
      type: Boolean,
      default: false
    },

    showResultsSummary: {
      type: Boolean,
      default: false
    },

    searchTerms: {
      type: Array,
      default: function() {
        return [];
      }
    },

    perPage: {
      type: Number,
      default: -1
    }
  },

  mixins: [resultsSummary],

  data: function() {
    return {
      inns: null,
      page: 1,
      offset: 0,
      totalPosts: null,
      searchMode: "grid",
      currentSearch: {},
      order: "rand",
      mapOptions: { scrollWheelZoom: false },
      clusterOptions: {
        removeOutsideVisibleBounds: false,
        showCoverageOnHover: false,
        disableClusteringAtZoom: 9
        // maxClusterRadius: 50
      },
      loading: true
    };
  },

  mounted: function() {
    let vm = this;

    if (vm.getPostsOnMount) {
      vm.getPosts();
    }

    Bus.$on("search-submit", function(data) {
      vm.buildResultsSummary(data);
      vm.getPosts(vm.prepareDataForSearch(data));
    });

    Bus.$on("option-deselect", function(option, category) {
      vm.modifySearch();
    });
  },

  methods: {
    popupMarkup: function(inn) {
      return `<div class="map-card">
        <div class="card-img relative" style="background-image:url(${
          inn.image
        })">
          <a href="${inn.link}" class="bg-link"></a>
        </div>
        <h4><a href="${inn.link}">${inn.title}</a></h4>
        <div class="card-details">
          <div>
            <span>${inn.city}, CA | ${inn.phone}</span><br>
            <a href="${inn.website}">Website</a>
          </div>
          <div class="card-bottom">
            <a href="${inn.link}" class="btn small btn-primary">View Details</a>
          </div>
        </div>
      </div>`;
    },

    getPosition: function(loc) {
      return L.latLng(loc.lat, loc.lng);
    },

    deselect: function(tag, i) {
      this.resultsSummary.splice(i, 1);
      Bus.$emit("option-deselect", tag, tag.type);
    },

    prepareDataForSearch: function(data) {
      let formattedData = {};

      for (let d in data) {
        if (typeof data[d] == "object") {
          // formattedData[d] = data[d].join(",");
          let slugs = data[d].map(obj => {
            return obj.slug;
          });
          formattedData[d] = slugs.join(",");
        } else {
          formattedData[d] = data[d];
        }
      }
      return formattedData;
    },

    getPosts: function(options = {}) {
      let vm = this;
      vm.loading = true;

      let params = Object.assign(
        {
          // offset: vm.offset,
          page: vm.page,
          per_page: vm.perPage
        },
        options
      );

      REST.get("/inns", {
        params: params
      })
        .then(function(response) {
          vm.currentSearch = params;
          vm.inns = response.data;
          vm.totalPosts = response.headers["x-wp-total"];
          vm.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          vm.loading = false;
        });
    }
  }
};
</script>

<style>
  .search-map {
    height: 100%;
    position: relative;
    z-index: 1;
  }
</style>
